import(/* webpackMode: "eager" */ "/app/refine/src/app/global-error.tsx");
